import { Component } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { Config } from '../config';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  public config = new Config();

  constructor(private translate: TranslateService) {
    translate.addLangs(['en-US', 'fr', 'ur', 'es', 'it', 'fa']);
    translate.setDefaultLang('nl-NL');
    const browserLang = translate.getBrowserLang();
    translate.use('nl-NL');

    let isExternal: boolean = false;
    if (window.location.search && window.location.search !== "") {
      let queryParams: any = decodeURIComponent(window.location.search).replace(/\s*/g, "").replace("?", "").toLowerCase().split("&");
      if (queryParams && queryParams.length > 0 && queryParams.includes("isexternal=true")) {
        isExternal = true;
      }
    }
    if (!isExternal) {
      localStorage.setItem('language', 'nl-NL');
    }

    // $('html').hover(function (e) {
    // if (e.target.id == 'menu-options' ) {
    //   $('header').toggleClass('open')
    // }
    // if(e.target.classList.contains('menu-toggler')){
    //   $('header').toggleClass('open');
    //   $('body').toggleClass('menu-toggler-body');  
    // }
    //   $('.menu-toggler').click(function() {
    //     $('header').toggleClass('open');      
    //     $('body').toggleClass('menu-toggler-body'); 
    //   });
    // });

  }
  notificationsOptions = {
    animate: 'scale',
    clickToClose: true,
    timeOut: 2000,
    preventLastDuplicates: 'visible',
    pauseOnHover: true,
    showProgressBar: false,
    position: ['bottom', 'right'],
    closeButton: true
  };

  ngOnInit(): void {
    if (window.self === window.top) {
      this.addGtmScript();
    }
  }

  addGtmScript() {
    //Add google tagmanager
    let scriptEle = document.createElement('script');
    scriptEle.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(

        {'gtm.start': new Date().getTime(),event:'gtm.js'}
        );var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${this.config.GtmCode}');`;
    document.head.insertBefore(scriptEle, document.head.childNodes[0]);

    //Add noscript
    let noscriptEle = document.createElement('noscript');
    noscriptEle.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${this.config.GtmCode}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscriptEle, document.body.childNodes[0]);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts